import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';

import { SystemSetting } from '../../../../shared/objects/systemSettings/system.settings';
import { PortalSetting } from '../../../../shared/objects/systemSettings/portal-setting';

@Injectable()
export class SystemSettingsService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}

  public getSystemSettings(): Observable<SystemSetting[]> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<SystemSetting[]>(
      `${environment.systemSettingServiceUrl}`,
      { headers },
    );
  }

  public getPortalSettings(): Observable<PortalSetting[]> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<PortalSetting[]>(
      `${environment.systemSettingServiceUrl}/portalSettings`,
      { headers },
    );
  }
  public addPortalSettings(
    portalSetting: PortalSetting,
  ): Observable<PortalSetting> {
    const headers = this.authService.getBearerRequestHeaders();

    return this.httpClient.post<PortalSetting>(
      `${environment.systemSettingServiceUrl}/addPortalSetting`,
      portalSetting,
      { headers },
    );
  }

  public editPortalSettings(
    portalSetting: PortalSetting,
  ): Observable<PortalSetting> {
    const headers = this.authService.getBearerRequestHeaders();

    return this.httpClient.put<PortalSetting>(
      `${environment.systemSettingServiceUrl}/editPortalSetting/${portalSetting.id}`,
      portalSetting,
      { headers },
    );
  }
}
